// extracted by mini-css-extract-plugin
export default {"button":"button---EP1MW","button__inner":"button__inner---p4oEP","button__label":"button__label---Gvz_K","button__label__inner":"button__label__inner---fPkin"};